export const attractionStrength = (
  dist: number,
  maxStrength: number,
): number => {
  if (dist <= 0) return 0;
  const PEAK = 1.0;
  const DECAY = Math.log(2) / Math.log(4);
  // Rise linearly 0→peak, then power-law decay
  if (dist < PEAK) return maxStrength * dist;
  return maxStrength * Math.pow(dist, -DECAY);
};
